import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { root } from './reducers';
import * as ActionCreators from './actionCreators';

const composeEnhancers =
  typeof window === 'object' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
    }) : compose;

const enhancer = composeEnhancers(
  applyMiddleware(thunk)
);

export const makeStore = () => createStore(root, enhancer);

export const buildStateSetter = (store) => {
    return state => store.dispatch(ActionCreators.setState(state));
};

export const buildStateGetter = store => store.getState;

export function observeStore(store, select, onChange) {
    let currentState = store.getState();

    function handleChange() {
        let prevState = currentState;
        currentState = select(store.getState());
        onChange(prevState, currentState);
    }

    let un = store.subscribe(handleChange);
    handleChange();
    return un;
}

